// packages
const { h, Component } = require('preact');
import { select, scaleLinear } from 'd3';
import { formatNumberPct, formatNumberWithCommas,formatNumberAnnotation } from '../../utils/utils';

// components

// internal

class LookupBar extends Component {
  constructor() {
    super();

    this.state = {}
  }

  drawBar() {
    console.log('LookupBar.drawBar() called with props:', this.props);
    const container = select(`.county-bar-container-${this.props.year}`);
    console.log('Container:', container.node());
    if (!container.node()) {
      console.error('Container not found for year:', this.props.year);
      return;
    }
    const width = container.node().clientWidth;
    const height = 78;
    const rectHeight = 30;
    const margin = { t: 30, r: 110, l: 0 };

    // set scales
    const xScale = scaleLinear()
      .domain([0, this.props.regVoters2024])
      .range([margin.l, width - margin.r]);
    
    const svg = container
      .append('svg')
      .attr('width', width)
      .attr('height', height)
    const barsG = svg.append('g')
      .attr('class', 'bars')
    // people who haven't voted
    barsG.append('rect')
      .attr('class', 'bar-not-voted')
      .attr('x', margin.l + xScale(this.props.voted+this.props.ev))
      .attr('y',  margin.t)
      .attr('width', xScale(this.props.regVoters - this.props.voted - this.props.ev))
      .attr('height', rectHeight)
      .attr('fill', 'lightgray')
      .attr('fill-opacity', 0.7)
      .attr('stroke', 'lightgray')
      .attr('stroke-width', 1.5)
    // people voted on election day
    if(this.props.year == 2026 || this.props.year == 2024 || this.props.year == 2022 || this.props.year == 2020){
    barsG.append('rect')
      .attr('class', 'bar-total-voted')
      .attr('x', margin.l + xScale(this.props.ev) + 1)
      .attr('y', margin.t)
      .attr('width', xScale(this.props.voted))
      .attr('height', rectHeight)
      .attr('fill', '#3fa293')
      .attr('fill-opacity', 0.7)
      .attr('stroke', '#3fa293')
      .attr('stroke-width', 1.5)
    }

    // people voted early
    barsG.append('rect')
      .attr('class', 'bar-ev')
      .attr('x', margin.l)
      .attr('y', margin.t)
      .attr('width', xScale(this.props.ev))
      .attr('height', rectHeight)
      .attr('fill', '#ffc200')
      .attr('fill-opacity', 0.7)
      .attr('stroke', '#ffc200')
      .attr('stroke-width', 1.5)

    // % voted
    const annotationsG = barsG.append('g')
      .attr('class', 'annotation')
    annotationsG.append('text')
      .attr('class', 'cum_ev')
      .attr('x', xScale(0) + 2)
      .attr('y', margin.t + rectHeight + 15)
      .style('font-weight', 'bold')
      .attr('fill', '#ffc200')
      .text(`${formatNumberPct(this.props.pct_ev * 100)} voted early`)
    if(this.props.year == 2026 || this.props.year == 2024 || this.props.year == 2022 || this.props.year == 2020) {
      const t = annotationsG.append('text')
        .attr('transform', `translate(${margin.l + xScale(+this.props.ev)}, 10)`)
        .attr('text-anchor', 'start')
        .style('font-weight', 'bold')
        .attr('fill', '#3fa293')
      t.append('tspan')
        .attr('x', 0)
        .attr('dy', 0)
        .text(`${formatNumberPct((this.props.voted) / this.props.regVoters * 100)} voted`)
      t.append('tspan')
        .attr('x', 0)
        .attr('dy', 15)
        .text('on election day')
    }

    // registered voters
    if (this.props.year == 2026) {
      const regVotersText = annotationsG.append('text')
        .attr('class', 'reg-voters')
        .attr('transform', `translate(${xScale(this.props.regVoters) + 10}, 40)`)
      regVotersText.append('tspan')
        .attr('x', 0)
        .attr('dy', 0)
        .text(formatNumberAnnotation(this.props.regVoters))
        .style('font-weight', 'bold')
      regVotersText.append('tspan')
        .attr('x', 0)
        .attr('dy', 15)
        .text('registered voters')
    } else {
      const regVotersText = annotationsG.append('text')
        .attr('class', 'reg-voters')
        .attr('transform', `translate(${xScale(this.props.regVoters) + 10}, 50)`)
      regVotersText.append('tspan')
        .attr('x', 0)
        .attr('dy', 0)
        .text(formatNumberAnnotation(this.props.regVoters))
        .style('font-weight', 'bold')
    }
  }

  redrawBar() {
    select(`.county-bar-container-${this.props.year}`)
      .select('svg')
      .remove()
    this.drawBar(); 
  }

  componentDidMount() {
      console.log('LookupBar.componentDidMount called for year:', this.props.year);
      this.drawBar();

      window.addEventListener('resize', () => {
        this.redrawBar();
      })
    }

  componentDidUpdate(prevProps) {
    if(prevProps.regVoters2024 != this.props.regVoters2024 || prevProps.ev != this.props.ev) {
      this.redrawBar();
    }
  }

  render() {   
    console.log('LookupBar.render() called for year:', this.props.year);
    return (
      <div class={`county-bar-container-${this.props.year}`}></div>
    )
  }
}

export default LookupBar;
